// util/Pixi*.bundle.min.js sarmalayıcıları (PixiEditor, PixiItemGroup, PixiQuota, PixiEquipment, PixiFb2c)
// YTP-pixie-seatmap `bug/pixi-destroy-leaks` derlemesinden geliyor ve destroy/pause/resume sunuyor.
// destroy(): ticker'ı durdurur, WebGL bağlamını ve window klavye dinleyicilerini bırakır, tuvali DOM'dan çıkarır;
// paylaşılan doku önbelleğine dokunmaz ve iki kez çağrılabilir. Bundle'lar bu dosyayla aynı derlemeye girdiği için
// eski (destroy'suz) bundle'a göre yedek yol tutulmuyor.

function callPixi(pixi, method) {
  if (!pixi || typeof pixi[method] !== "function") return;
  try {
    pixi[method]();
  } catch (e) {
    console.warn(`Pixi örneğinde ${method} çalışmadı:`, e);
  }
}

export function destroyPixiInstance(pixi) {
  callPixi(pixi, "destroy");
}

// Yeniden kullanım için saklanan örneğin tuvali sayfada değilken her karede boşa çizmesin.
export function pausePixiInstance(pixi) {
  callPixi(pixi, "pause");
}

export function resumePixiInstance(pixi) {
  callPixi(pixi, "resume");
}
